import React, { useState, useEffect, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';

import Card from '../../../Components/Card/Card';
import Icon from '../../../Components/icon/Icon';
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid';

import { getMenus } from '../../../API/IT/Menu/MenuRequests';
import { putActividadMenu } from "../../../API/IT/Menu/MenuRequests"

import ModalMenu from './EditarMenu/EditarMenu';
import PermisosUser from './EditarMenu/PermisosUser';

import { AuthContext } from '../../../Context/AuthContext/AuthContext';
import { ConfigContext } from '../../../Context/ConfigContext/ConfigContext';
import { baseLang } from '../../../Lang/BaseLang';
import { setTitlePage } from '../../../Services/Config/ConfigService';
import { getLabel } from '../../../Services/Language/LanguageService';



const MenuScreen = () => {

  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [menuDialog, setMenuDialog] = useState(false);
  const [IdMenu, setIdMenu] = useState(0)
  const [showDialogUser, setShowDialogUser] = useState(false);

  const openDialog = (Id) => {
    setMenuDialog(true)
    setIdMenu(Id)
  }

  const hideDialog = () => {
    setMenuDialog(false)
    getListadoMenu()
  }


  const onChangeCheck = async (activo, IdMenu, e) => {
    let activosMenu = {
      Menu: activo,
      Activo: e,
      IdMenu: IdMenu
    }


    const result = await putActividadMenu(activosMenu)
    const temporal = result.map((item) => {
      // console.log(item)
      if (item.id === IdMenu) {
        item.ActivoApp = true
      }
      return item
    })
    setData(temporal)

    // setData(result)
  }

  const colums = [
    {
      // IdMenu: 1,
      field: 'IdMenu',
      header: 'IdMenu',
      headerEn:'IdMenu',
      hidden: userAuth.IdRol === 1,
      className: 'colum-width-Xsmall',
      onCellDoubleClicked: ({ data }) => {
        openDialog(data.IdMenu);
      },
      body: (rowData) => rowData.IdMenu,
    },
    {
      // Menu: 'Menu',
      field: 'Menu',
      header: 'Menú',
      headerEn:'Menu',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        openDialog(data.IdMenu);
      },
      body: (rowData) => rowData.Menu,
    },
    {
      // Menu: 'Menu',
      field: 'Titulo',
      header: 'Titulo',
      headerEn:'Title',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        openDialog(data.IdMenu);
      },
      body: (rowData) => rowData.Titulo,
    },
    {
      // Menu: 'Menu',
      field: 'Title',
      header: 'Title',
      headerEn:'Title',
      className: 'medium',
      onCellDoubleClicked: ({ data }) => {
        openDialog(data.IdMenu);
      },
      body: (rowData) => rowData.Title,
    },
    {
      // URL
      field: 'URL',
      header: 'URL',
      headerEn:'URL',
      className: 'medium',
      flex:1,
      minWidth: 200,
    },
    {
      // Contenedor
      field: 'Contenedor',
      header: 'Contenedor',
      headerEn:'Container',
      className: 'medium',
      body: (rowData) => rowData.Contenedor,
    },
    {
      // Orden
      field: 'Orden',
      header: 'Orden',
      headerEn:'Order',
      className: 'medium',
      body: (rowData) => rowData.Orden,

    },
    {
      // Icon
      field: 'Icon',
      header: 'Icono Web',
      headerEn:'Icon Web',
      className: 'colum-width-small',
      body: (rowData) => <Icon icon={rowData.Icon ? rowData.Icon : 'a'} />,
      align: 'center',
      Format: 'Icon',
      filter: false
    },
    {
      // IconApp
      field: 'IconApp',
      header: 'Icono App',
      headerEn:'Icon App',
      className: 'colum-width-small',
      body: (rowData) => <Icon icon={rowData.IconApp ? rowData.IconApp : 'a'} />,
      align: 'center',
      Format: 'Icon',
      filter: false
    },
    {
      // MenuWeb
      field: 'MenuWeb',
      header: 'Menú Web',
      headerEn:'Menu Web',
      className: 'Xsmall',
      align: 'center',
      Format: "Checkbox",
      filter: false,
      body: (rowData) => <Checkbox onChange={(e) => onChangeCheck(1, rowData.IdMenu, e.checked)} style={{ marginBottom: 5 }} checked={rowData.MenuWeb} />,

    },
    {
      // MenuWeb
      field: 'ActivoApp',
      header: 'Activo App',
      headerEn:'Active App',
      className: 'Xsmall',
      align: 'center',
      Format: "Checkbox",
      filter: false,
      body: (rowData) => <Checkbox onChange={(e) => onChangeCheck(1, rowData.IdMenu, e.checked)} style={{ marginBottom: 5 }} checked={rowData.ActivoApp} />,

    },
    {
      frozen: true,
      alignFrozen: "right",
      field: "IdMenu",
      className: 'Xsmall',
      textAlign: 'center',
      header: "",
      Format: "Botones",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            openDialog(rowData.IdMenu)
          },
        },
        {
          icon: "pi ri-tools-fill",
          tooltip: "Permisos",
          onClick: (rowData) => {
            setShowDialogUser(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ]
    }
  ]

  const table = {
    Data: data,
    Columns: colums,
    key: 'IdMenu',
    loading: loading
  }



  const getListadoMenu = async () => {
    setLoading(true);
    const result = await getMenus();
    setData(result)
    setLoading(false);
  }

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "menu", config.language));
    getListadoMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div style={{ width: '99%' }}>
      <Toast position="bottom-right" ref={toast} />
      <Card
        titulo={
          <div className="d-flex my-2" style={{ alignItems: 'center' }}>
            <h3 className="mx-3">{getLabel(baseLang, "menu", config.language)}</h3>
            <Button className=" mx-2" icon="ri-restart-line" loading={loading} onClick={getListadoMenu} />
            <Button icon='pi pi-plus' onClick={() => openDialog(0)} severity='success' />
          </div>}
        contenido={
          <div className='pt-5' style={{ height: '90vh' }}>
            <AgGrid table={table} />
          </div>
        }
      />
      <ModalMenu
        menuDialog={menuDialog}
        setMenuDialog={setMenuDialog}
        hideDialog={hideDialog}
        IdMenu={IdMenu}
      />
      {showDialogUser && <PermisosUser toast={toast} showDialogUser={showDialogUser} selected={selected} setShowDialogUser={setShowDialogUser} getAccesos={onChangeCheck} />}
    </div>
  )
}

export default MenuScreen;